import { isMatch } from "lodash";
import { Navigate } from "react-router-dom";
import { useUsuario } from "../../../providers/usuarioProvider";
import Permissoes from "../../../models/permissoes";
import { useLocation } from "react-router-dom";
import { PropsWithChildren } from "react";

export default function PrivateRoleRoute({
  children,
  match,
}: PropsWithChildren<{ match: Partial<Permissoes> }>) {
  const location = useLocation();
  const { isLoading, isAuthenticated, claims } = useUsuario();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!claims?.perfil) {
    return null;
  }

  if (claims?.permissoes && isMatch(claims.permissoes, match)) {
    return <>{children}</>;
  }

  return <Navigate to="/painel" state={{ from: location }} replace />;
}
